import { render, staticRenderFns } from "./TagTitle.vue?vue&type=template&id=1afcf864&scoped=true&"
import script from "./TagTitle.vue?vue&type=script&lang=ts&"
export * from "./TagTitle.vue?vue&type=script&lang=ts&"
import style0 from "./TagTitle.vue?vue&type=style&index=0&id=1afcf864&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1afcf864",
  null
  
)

export default component.exports